import React from 'react';

const InputComponent = ({autoFocus, fontWeight, max,min, label, name,required,divclass, placeholder, type, width,height, onChange,minHeight, value, id, className, disabled,onBlur }) => {
  return (
    <div className={`custm_form_field ${ divclass}`} style={{ width: width }}>
      <label className={`input_labels`} htmlFor="eventName" style={{fontWeight: fontWeight}}>
        {label}<span className='text-danger'>{required}</span>
      </label>
      <input
      style={{ width: width, height:height, minHeight:minHeight }}
        name={name}
        max={max}
        className={className}
        id={id}
        type={type}
        placeholder={placeholder}
        value={value}
        disabled={disabled}
        onChange={onChange}
        min={min}
        onBlur={onBlur}
        autoFocus={autoFocus}
      />
    </div>
  );
};

export default InputComponent;


